module.exports = __webpack_public_path__ + "img/p13.2113dddd.png";